import { render, staticRenderFns } from "./ChartContributions.vue?vue&type=template&id=12296ddc&scoped=true&"
import script from "./ChartContributions.vue?vue&type=script&lang=ts&"
export * from "./ChartContributions.vue?vue&type=script&lang=ts&"
import style0 from "./ChartContributions.vue?vue&type=style&index=0&id=12296ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12296ddc",
  null
  
)

/* custom blocks */
import block0 from "./ChartContributions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VProgressCircular,VSheet})
